import { Button } from "@mui/material";
import { Link, RouteComponentProps } from "react-router-dom";
import { LinksList } from "./LinksList";

export default function LinksPage(props: RouteComponentProps) {
  return (
    <>
      <Link style={{ textDecoration: 'none', marginBottom: '1em' }} to="/edit-link">
        <Button variant="contained">New Link</Button>
      </Link>
      <LinksList />
    </>
  );
}
